export const moreTranslations: Record<string, Record<string, any>> = {
  en: {
    navbar: {
      aiAutomations: "AI Automations",
      services: "Services",
      aboutCompany: "About Company",
      leadership: "Leadership",
      blog: "Blog Chronicles",
      caseStudies: "Case Studies"
    },
    services: {
      dedicatedPartnerHeader: "Your Dedicated Partner for",
      alternatingKeywords: ["Healthcare SaaS", "HR SaaS", "Construction SaaS", "Logistics SaaS"],
      tag: "Custom Product Studio / We Build, Scale & Maintain SaaS Platforms",
      title: "Your Dedicated Partner for Custom SaaS Engineering",
      desc: "Teralumax operates as an elite Software Product Studio. We build, scale, and maintain tailor-made SaaS platforms and custom digital products from architectural blueprint to global scale, helping potential clients secure reliable, long-term technical execution and product success.",
      b1Tag: "SaaS & Product Development",
      b1Title: "Full-Lifecycle SaaS Engineering",
      b1Desc: "We build custom web apps and production SaaS systems with absolute type-safety, robust cloud scale, and continuous proactive maintenance.",
      b2Tag: "Visual Systems & Interfaces",
      b2Title: "High-Converting Tactile UI/UX",
      b2Desc: "We design and build bespoke high-contrast interfaces with fluid interactive transitions, keeping your app intuitive, professional, and optimized for sales and retention.",
      b3Tag: "Scale & Database Infrastructure",
      b3Title: "Secure Cloud Architecture & Maintenance",
      b3Desc: "We configure, monitor, and scale robust relational databases (PostgreSQL, Firestore), custom API pipelines, and secure cloud environments designed for millions of user requests.",
      b4Tag: "SEO & Growth Engine Optimizer",
      b4Title: "World-Class Domain SEO & Performance",
      b4Desc: "We embed automated structured breadcrumbs, crawlable JSON-LD schemas, and native multilingual indexation so your SaaS platform ranks at the top of search result pages naturally.",
      guaranteeTitle: "Ready to design, engineer, and scale your custom platform with Teralumax?",
      guaranteeDesc: "We provide complete product-level guarantees: guaranteed sub-second load times, military-grade cloud encryption with dynamic firewalls, automated daily database backups, and premium search engine discoverability."
    },
    footer: {
      desc: "We design, code, and deploy lightweight elegant products and cloud interfaces for digital native startups across the globe.",
      productsHeader: "Products Portfolio",
      companyHeader: "Company Node",
      documentation: "Documentation",
      contact: "Contact",
      philosophy: "We design, code, and deploy lightweight elegant products and cloud interfaces for digital native startups across the globe."
    },
    contact: {
      privacyText: "Secure 256-bit SSL encrypted connection.",
      anotherCta: "Send Another Message"
    },
    aboutPage: {
      meta: "About Teralumax",
      title: "About Teralumax Private Limited",
      subtitle: "Building Digital Products with Purpose.",
      paragraph1: "Teralumax Private Limited is a technology company dedicated to building modern software products that simplify everyday operations for businesses and individuals. We believe great software should be intuitive, reliable, and built to scale. Every product we create is driven by thoughtful design, strong engineering, and a commitment to solving real-world problems.",
      paragraph2: "Founded in 2025, Teralumax focuses on creating innovative SaaS platforms, enterprise solutions, mobile applications, and digital experiences that empower users through technology. From property management and workforce solutions to consumer applications, our mission is to build products that make work smarter and life simpler.",
      statIncorporation: "Founded",
      statIncorporationVal: "2025",
      statClass: "Company Type",
      statClassVal: "Private Limited",
      statActive: "Industry State",
      statActiveVal: "Active",
      companyNameLabel: "Company Name",
      companyNameValue: "Teralumax Private Limited",
      foundedLabel: "Founded Date",
      foundedValue: "23 June 2025",
      companyTypeLabel: "Company Type",
      companyTypeValue: "Private Limited Company",
      industryLabel: "Industry",
      industryValue: "Software Development • SaaS Products • Enterprise Applications • Mobile Solutions",
      hqLabel: "Headquarters",
      hqValue: "Pune, Maharashtra, India",
      officeLabel: "Registered Office",
      officeValue: "375, Nanekarwadi Fata, Chakan, Taluka Khed, District Pune, Maharashtra – 410501, India",
      missionLabel: "Our Mission",
      missionValue: "To build simple, intelligent, and scalable digital products that help businesses and individuals work more efficiently while delivering exceptional user experiences.",
      visionLabel: "Our Vision",
      visionValue: "To become a globally recognized technology company known for creating impactful software products that combine innovation, simplicity, and reliability.",
      whatWeBuildLabel: "What We Build",
      whatWeBuildItems: [
        "SaaS Platforms",
        "Enterprise Software",
        "Web Applications",
        "Mobile Applications",
        "Business Automation Solutions",
        "AI-Powered Digital Products",
        "Cloud-Based Software"
      ]
    },
    leadershipPage: {
      meta: "Leadership & Board of Directors",
      title: "Board of Directors",
      subtitle: "The visionaries behind Teralumax's design, governance, and product engineering.",
      aboutAbhishek: "Abhishek Vadave",
      roleAbhishek: "Founder & Director",
      bioAbhishek: "Abhishek Vadave is the Founder and Director of Teralumax Private Limited. With a passion for technology, product innovation, and user-centric design, he leads the company's vision of building software that solves meaningful problems through simplicity, performance, and modern engineering. His focus is on creating products that deliver long-term value while maintaining exceptional quality and user experience.",
      aboutOmkar: "Omkar Vadave",
      roleOmkar: "Director",
      bioOmkar: "Omkar Vadave is Director at Teralumax Private Limited. He plays a key leadership role in strategic growth, corporate governance, operational execution, and expanding the company's software products and enterprise partnerships.",
      philosophyTitle: "Our Philosophy",
      philosophyQuote: "Build with Purpose. Design with Simplicity. Innovate for Everyone.",
      philosophyText: "Every line of code, every interface, and every product is crafted with the belief that technology should feel effortless, intuitive, and accessible. At Teralumax, we don't just build software—we create digital experiences that people enjoy using every day."
    },
    automations: {
      badge: "AUTONOMOUS BUSINESS OPERATIONS & AI GROWTH ENGINE",
      title: "Stop Losing Inbound Revenue to Response Lag & Unanswered Calls",
      subtitle: "Every minute a prospect waits is a minute they give to a competitor. Deploy 24/7 human-grade AI agents across Voice Calls, WhatsApp, Email, and CRM workflows—capturing, qualifying, and booking appointments automatically.",
      tabVoice: "Autonomous Voice Agent",
      tabWhatsapp: "WhatsApp Commerce",
      tabEmail: "Zero-Delay Email Triage",
      tabOmni: "CRM & Workflow Sync",
      tabSupport: "24/7 Support Desk",
      voiceTitle: "Turn Inbound Phone Calls Into Confirmed Revenue 24/7",
      voiceDesc: "Eliminate missed calls and voicemail lead decay. Our human-sounding Voice AI answers on the first ring, answers complex business questions using your documentation, checks real-time calendar availability, and books qualified appointments on the spot.",
      voiceFeature1: "Responds in under 280ms with human-grade voice prosody & accent adaptability",
      voiceFeature2: "Checks live staff schedules on Google & Outlook to book sales calls directly",
      voiceFeature3: "Warm-transfers high-priority VIP buyers directly to on-call team mobile phones",
      voiceFeature4: "Automatically logs call recordings, audio transcripts, and sentiment scores in your CRM",
      voiceStat1: "LATENCY",
      voiceStat1Val: "< 280ms",
      voiceStat2: "ANSWER RATE",
      voiceStat2Val: "100% Guaranteed",
      voiceStat3: "CAPACITY",
      voiceStat3Val: "10,000+ Calls",
      voiceBoxTitle: "LIVE TELEPHONY CALL TRANSCRIPT",
      voiceBoxStatus: "24/7 ACTIVE TELEPHONY NODE",
      voiceSpeakerAgent: "AI Voice Agent",
      voiceSpeakerCaller: "Inbound Lead",
      voiceMsg1: "Hello! Thank you for calling Teralumax. I'm your AI Assistant. How can I assist your team today?",
      voiceMsg2: "Hi! We're losing inbound sales leads on weekends. Can your AI handle phone inquiries and book enterprise demos?",
      voiceMsg3: "Absolutely! I answer questions using your documentation, check live staff calendars, and schedule confirmed demos instantly. Shall I book a slot for tomorrow at 2:00 PM EST?",
      voiceMsg4: "Yes, tomorrow at 2:00 PM EST works perfectly!",
      voiceMsg5: "Done! I've reserved tomorrow at 2:00 PM EST on Google Calendar, created your lead profile in HubSpot, and emailed a calendar invite.",
      voiceConfirmed: "Auto-Booked to Google Calendar & HubSpot CRM • CONFIRMED",
      waTitle: "Turn WhatsApp Messages Into Instant Sales & Bookings",
      waDesc: "Capitalize on WhatsApp's 98% open rate. Engage inbound leads immediately, deliver interactive PDF catalogs, qualify buyer budgets automatically, and secure sales consultations inside WhatsApp without human friction.",
      waFeature1: "Official Meta WhatsApp Business Cloud API green-badge verified integration",
      waFeature2: "Sends interactive product cards, price quotes, audio voice notes & booking buttons",
      waFeature3: "Automated B2B lead scoring and budget qualification algorithms",
      waFeature4: "Seamless live-human escalation dashboard for high-value sales reps",
      waStat1: "SPEED TO LEAD",
      waStat1Val: "< 1 Second",
      waStat2: "OPEN RATE",
      waStat2Val: "98.4%",
      waStat3: "CONVERSION",
      waStat3Val: "3.8x Growth",
      waAgentHeader: "Teralumax WhatsApp Agent",
      waAgentStatus: "Online • Instant Reply",
      waMetaBadge: "Meta Cloud API",
      waMsg1: "Hi! Can an AI Voice & WhatsApp agent handle our inbound leads and book meetings automatically?",
      waMsg2: "Hello! Yes, absolutely. Our AI responds in under 1 second via Meta WhatsApp Business API. It qualifies buyer budgets, shares interactive product catalogs, and books meetings on your calendar.",
      waMsg3: "How fast does it integrate with our CRM like HubSpot or Salesforce?",
      waMsg4: "In under 15 minutes! The AI automatically creates contacts, tags lead intent, logs transcripts, and syncs calendar invites on staff schedules.",
      waActionPill: "📅 Book Strategy Audit (Auto-Synced)",
      emailTitle: "Zero Inbox Lag: Instant Proposal & Lead Processing Engine",
      emailDesc: "Transform slow email response times into instant competitive advantages. Automatically classify incoming inquiries, generate contextually accurate draft replies, and attach direct calendar invites before competitors even open their inbox.",
      emailFeature1: "Eliminates response lag—replies instantly 24 hours a day, 365 days a year",
      emailFeature2: "AI intent classifier categorizes Sales, VIP, Billing, and Support inquiries",
      emailFeature3: "Synthesizes company knowledge bases, FAQs, and price matrices into personalized replies",
      emailFeature4: "Instantly alerts sales reps on Slack/Teams when high-value enterprise leads write in",
      emailStat1: "INBOX DELAY",
      emailStat1Val: "0 Minutes",
      emailStat2: "TIME SAVED",
      emailStat2Val: "15+ Hrs/Wk",
      emailStat3: "ACCURACY",
      emailStat3Val: "99.2%",
      emailBoxHeader: "INBOX TRIAGE ENGINE",
      emailBoxStatus: "0 MINS DELAY",
      emailFrom: "From: director@enterprise.com",
      emailTime: "Just now",
      emailSubject: "Subject: Custom AI implementation inquiry",
      emailBody: "\"Looking to automate inbound phone calls and email triage for our 50+ sales reps.\"",
      emailStep1: "1. Intent Classified",
      emailStep2: "2. Knowledge Synthesized",
      emailStep3: "3. Calendar Linked",
      emailReplyTitle: "AUTOMATED RESPONSE GENERATED",
      emailReplyBody: "\"Hi Director! Based on your team size, our Enterprise Architecture fits seamlessly. I've reserved a strategy slot for you below.\"",
      emailIntentLabel: "Buying Intent:",
      emailIntentVal: "High (98/100)",
      emailRoutedLabel: "Routed to:",
      emailRoutedVal: "HubSpot + Slack",
      omniTitle: "Zero Manual Entry: Bi-Directional CRM & Workflow Orchestration",
      omniDesc: "Unify every phone call, WhatsApp conversation, and email thread into your core enterprise tech stack. Automatically create contacts, update pipeline deals, log notes, and trigger post-interaction SMS & email follow-up drips.",
      omniFeature1: "50+ pre-built native integrations: HubSpot, Salesforce, Zoho, Google Sheets, Slack, Zapier",
      omniFeature2: "Real-time webhook pipelines for proprietary SQL databases & internal ERPs",
      omniFeature3: "Automated post-interaction SMS & WhatsApp nurturing drip campaigns",
      omniFeature4: "Instant team notifications across Slack, Microsoft Teams, and SMS",
      omniStat1: "CONNECTORS",
      omniStat1Val: "50+ Native",
      omniStat2: "DATA SYNC",
      omniStat2Val: "Real-Time (0s)",
      omniStat3: "ERRORS",
      omniStat3Val: "0% Manual",
      omniBoxHeader: "BI-DIRECTIONAL SYNC PIPELINE",
      omniBoxStatus: "LIVE STREAM",
      omniStep1Title: "Inbound Call / WhatsApp Completed",
      omniStep1Tag: "Trigger",
      omniStep2Title: "AI Transcript & Sentiment Extraction",
      omniStep2Tag: "Processing",
      omniStep3Title: "HubSpot Deal Created & Assigned",
      omniStep3Tag: "Synced (0s)",
      omniCrmList: "Supported CRMs: HubSpot, Salesforce, Zoho, Google Sheets",
      supportTitle: "Autonomous 24/7 Customer Support & Desk Triage",
      supportDesc: "Delight customers with instant 24/7 answers to technical FAQs, order status inquiries, and billing questions. Cut support operational costs by up to 70% while improving your CSAT scores.",
      supportFeature1: "Resolves 80%+ of tier-1 support inquiries autonomously without human staff intervention",
      supportFeature2: "Integrated with Shopify, Zendesk, Intercom, and custom database knowledge bases",
      supportFeature3: "Smart escalation routes complex edge cases to human support reps with full context summaries",
      supportFeature4: "Multilingual fluency across 50+ global languages for international business reach",
      supportStat1: "RESOLVED",
      supportStat1Val: "80%+ Instant",
      supportStat2: "SAVINGS",
      supportStat2Val: "Up to 70%",
      supportStat3: "CSAT",
      supportStat3Val: "98.7%",
      supportBoxHeader: "SUPPORT DESK TICKET RESOLUTION",
      supportBoxStatus: "AUTONOMOUS",
      supportQueryLabel: "Customer Query:",
      supportQueryVal: "\"Where is my order #TR-8492 and can I update my shipping address?\"",
      supportResLabel: "AI Resolution (< 1s):",
      supportResVal: "\"Order #TR-8492 is out for delivery. Address updated in Shopify and notification sent via SMS!\"",
      supportLangLabel: "Languages:",
      supportLangVal: "50+ Supported",
      supportStatusLabel: "Ticket Status:",
      supportStatusVal: "Resolved",
      roiTag: "REVENUE RECOVERY ESTIMATOR",
      roiTitle: "Calculate Your Monthly Inbound Revenue Recovery",
      roiSub: "See how much revenue an Autonomous AI Agent recovers by capturing missed calls & delayed inquiries instantly.",
      roiLabelInquiries: "Monthly Inbound Inquiries",
      roiLabelDealValue: "Average Customer Deal Value ($)",
      roiLabelMissedRate: "Estimated Missed/Delayed Leads (%)",
      roiStatLeads: "LEADS CAPTURED",
      roiStatLeadsUnit: "Inquiries / Mo",
      roiStatHours: "HOURS SAVED",
      roiStatHoursUnit: "Staff Time / Mo",
      roiStatRevenue: "EST. REVENUE RECOVERED",
      roiStatRevenueUnit: "Recovered / Mo",
      faqTag: "FREQUENTLY ASKED QUESTIONS",
      faqTitle: "AI Business Automations & Receptionist FAQ",
      faqQ1: "How does an Autonomous AI Voice Agent handle inbound phone calls for a business?",
      faqA1: "An Autonomous AI Voice Agent uses ultra-low latency (<280ms) natural speech synthesis and large language models to converse naturally with human callers. It answers FAQs from your company documentation, checks live staff calendars (Google Workspace/Outlook), books appointments, and warm-transfers high-priority calls directly to staff mobile devices.",
      faqQ2: "What is the speed-to-lead advantage of AI Business Automations?",
      faqA2: "Contacting an inbound lead within 60 seconds yields a 391% higher conversion rate compared to a 30-minute delay. An Autonomous AI Ecosystem responds instantly (<1 second) across Phone, WhatsApp, and Email—ensuring zero lead decay and maximum revenue capture.",
      faqQ3: "Can WhatsApp Business AI Assistants send PDF catalogs and book meetings inside chat?",
      faqA3: "Yes! Utilizing the official Meta WhatsApp Business Cloud API, our WhatsApp AI Assistants deliver interactive product cards, price quotes, audio voice notes, and instant calendar booking widgets directly inside WhatsApp.",
      faqQ4: "How does the AI Automation Engine sync with CRMs like HubSpot, Salesforce, and Zoho?",
      faqA4: "The automation system operates via bi-directional real-time webhooks and REST API integrations. Every phone call transcript, voice recording, WhatsApp chat summary, and email thread is instantly structured into lead profile records and deal pipeline stages in your CRM.",
      faqQ5: "Is customer data secure and compliant?",
      faqA5: "Data transit is encrypted using enterprise-grade TLS 1.3 and AES-256 encryption at rest. The architecture adheres to SOC-2 Type II standards, HIPAA guidelines, and GDPR/CCPA privacy frameworks. Your company documentation and customer transcripts are never used to train public LLM models.",
      faqQ6: "How quickly can a business deploy a custom AI Voice & Operations Engine?",
      faqA6: "Deployment takes under 48 hours. Our engineering team ingests your existing company documentation, connects your phone numbers and CRM APIs, tests edge cases in a staging sandbox, and launches your 24/7 autonomous ecosystem seamlessly.",
      ctaTag: "48-HOUR DEPLOYMENT",
      ctaTitle: "Ready to Automate Your Inbound Operations?",
      ctaSub: "Deploy custom AI Voice & Business Automation agents trained on your business documentation in under 48 hours.",
      ctaBtnPrimary: "Book AI Architecture Audit"
    }
  },
  es: {
    navbar: {
      services: "Servicios",
      aboutCompany: "Sobre la Empresa",
      leadership: "Liderazgo",
      blog: "Crónicas Técnicas",
      caseStudies: "Casos de Éxito",
      proptech: "SaaS PropTech"
    },
    services: {
      dedicatedPartnerHeader: "Su socio dedicado para",
      alternatingKeywords: ["SaaS de Salud", "SaaS de RRHH", "SaaS de Construcción", "SaaS de Logística"],
      tag: "Servicios a medida / Crecimiento Corporativo",
      title: "Nuestros Servicios de Ingeniería y Desarrollo Personalizados",
      desc: "No solo creamos nuestros propios productos SaaS; nos asociamos con clientes potenciales y empresas modernas para diseñar, estructurar y lanzar soluciones de software personalizadas de nivel internacional.",
      b1Tag: "Desarrollo de SaaS y Apps",
      b1Title: "Ingeniería de Software Full-Stack",
      b1Desc: "Aplicaciones web personalizadas, plataformas SaaS robustas y productos nativos de alto rendimiento creados con seguridad de tipos absoluta, canales de datos rápidos y velocidades optimizadas.",
      b2Tag: "Sistemas de Diseño e UI",
      b2Title: "UX Táctil e Interfaces Dinámicas",
      b2Desc: "Diseños vectoriales interactivos, estética premium de alto contraste y transiciones fluidas con motion/react, mejorando el compromiso a través de detalles sensoriales premium.",
      b3Tag: "Arquitectura de Nube y Seguridad",
      b3Title: "Base de Datos Segura y Escalamiento en la Nube",
      b3Desc: "Estructuras de tablas relacionales, integraciones personalizadas y cortafuegos herméticos (con validación de IP de cliente) listos para el despliegue global.",
      b4Tag: "Estrategia Empresarial y SEO",
      b4Title: "SEO Internacional y Alto Rendimiento",
      b4Desc: "Esquemas JSON-LD listos para rastreo, automatización de migas de pan, sincronización de metadatos y soporte multilingüe nativo para la máxima visibilidad.",
      guaranteeTitle: "¿Listo para construir una plataforma personalizada con Teralumax?",
      guaranteeDesc: "Cada colaboración funciona bajo garantías de rendimiento completas: tiempos de carga de subsegundo, diseño adaptativo impecable, infraestructura robusta y optimización SEO premium."
    },
    footer: {
      desc: "Diseñamos, programamos e implementamos productos livianos y elegantes de interfaz en la nube para startups globales.",
      productsHeader: "Portafolio de Productos",
      companyHeader: "Nodo de la Compañía",
      documentation: "Documentación",
      contact: "Contacto",
      philosophy: "Diseñamos, programamos e implementamos productos livianos y elegantes de interfaz en la nube para startups globales."
    },
    contact: {
      privacyText: "Conexión segura encriptada SSL de 256 bits.",
      anotherCta: "Enviar Otro Mensaje"
    },
    aboutPage: {
      meta: "Perfil Corporativo",
      title: "Teralumax Private Limited",
      subtitle: "Incorporada el 22 de noviembre de 2022",
      cin: "CIN / Número de Identificación Corporal",
      cinValue: "U72900DL2022PTC407338",
      addressLabel: "Dirección Registrada",
      addressValue: "Sec-5, Vaishali, Ghaziabad, Uttar Pradesh, India - 201010",
      statusLabel: "Estado de Registro",
      statusValue: "Activa (Sociedad Privada No Cotizada Limitada por Acciones)",
      domainLabel: "Dominio Digital",
      domainValue: "Ingeniería de Software y Arquitecturas de Productos Digitales",
      paragraph1: "Teralumax Private Limited es una empresa de tecnología élite constituida el 22 de noviembre de 2022. Operando en la intersección de la ingeniería backend estructural y la precisión del diseño visual, creamos productos modernos diseñados para reemplazar las plantillas genéricas por experiencias de software rápidas, hermosas y sensoriales.",
      paragraph2: "Desde la reserva inteligente de escritorios y espacios de trabajo (Roomy™) hasta la creación visual basada en esquemas relacionales sin código (SiteForces) y juegos móviles geométricos de alta velocidad (Arrow Escape en Google Play Store), Teralumax representa un santuario de ingeniería fundado desde los primeros principios.",
      statIncorporation: "Incorporación",
      statClass: "Clase de Empresa",
      statClassVal: "Empresa Privada",
      statActive: "Estado de Registro",
      statActiveVal: "Activa / MCA"
    },
    leadershipPage: {
      meta: "Comando Ejecutivo",
      title: "Junta Directiva",
      subtitle: "Los arquitectos que dirigen la trayectoria tecnológica de Teralumax.",
      aboutAbhishek: "Abhishek Balu Vadave",
      roleAbhishek: "Fundador y Director General",
      bioAbhishek: "Abhishek Balu Vadave es la fuerza impulsora, fundador y creador detrás de Teralumax Private Limited. Guiado por valores profundos de lógica computacional y tipografía equilibrada, crea conceptos de productos y diseña flujos de interfaces rápidas y confiables. Promueve el orden riguroso en el código para manifestar productos como auténtica artesanía.",
      aboutBalu: "Balu Laxman Vadave",
      roleBalu: "Director de Gobernanza",
      bioBalu: "Balu Laxman Vadave es codirector en la junta de Teralumax, liderando las finanzas estratégicas, las normativas corporativas institucionales y la planificación operacional para mantener una sincronización óptima del nodo de la compañía.",
      missionTitle: "Filosofía de Ingeniería",
      missionText: "Creemos que la tecnología debe actuar como un compañero natural de la productividad humana. Priorizamos código limpio, peso mínimo de datos y máxima velocidad de respuesta."
    },
    automations: {
      badge: "OPERACIONES COMERCIALES AUTÓNOMAS Y MOTOR DE CRECIMIENTO IA",
      title: "Deje de perder ingresos por demoras en respuesta y llamadas sin contestar",
      subtitle: "Cada minuto que un prospecto espera es un minuto que se va con la competencia. Despliegue agentes de IA las 24/7 en llamadas de voz, WhatsApp, correo y flujos CRM.",
      tabVoice: "Agente de Voz Autónomo",
      tabWhatsapp: "Comercio por WhatsApp",
      tabEmail: "Clasificación de Correo en 0s",
      tabOmni: "Sincronización CRM y Flujos",
      tabSupport: "Soporte Técnico 24/7",
      voiceTitle: "Convierta llamadas telefónicas entrantes en ingresos confirmados 24/7",
      voiceDesc: "Elimine las llamadas perdidas y el correo de voz. Nuestra IA de voz con sonido humano responde al primer tono, aclara dudas de su empresa y programa citas calificadas al instante.",
      voiceFeature1: "Responde en menos de 280ms con prosodia humana y adaptabilidad de acento",
      voiceFeature2: "Consulta calendarios en vivo en Google y Outlook para agendar reuniones directamente",
      voiceFeature3: "Transfiere llamadas VIP de alta prioridad a los teléfonos móviles de su equipo",
      voiceFeature4: "Registra automáticamente grabaciones, transcripciones y puntuación de sentimiento en su CRM",
      voiceStat1: "LATENCIA",
      voiceStat1Val: "< 280ms",
      voiceStat2: "RESPUESTA",
      voiceStat2Val: "100% Garantizada",
      voiceStat3: "CAPACIDAD",
      voiceStat3Val: "10,000+ Llamadas",
      voiceBoxTitle: "TRANSCRIPCIÓN DE LLAMADA TELEFÓNICA EN VIVO",
      voiceBoxStatus: "NODO TELEFÓNICO ACTIVO 24/7",
      voiceSpeakerAgent: "Agente de Voz IA",
      voiceMsg1: "¡Hola! Gracias por llamar a Teralumax. Soy su asistente virtual de IA. ¿En qué puedo ayudarle hoy?",
      voiceSpeakerCaller: "Cliente Entrante",
      voiceMsg2: "¡Hola! Perdemos ventas los fines de semana. ¿Su IA puede responder llamadas y agendar demos corporativas?",
      voiceSpeakerAgentReply: "Agente de Voz IA",
      voiceMsg3: "¡Absolutamente! Nuestro motor atiende llamadas 24/7 y puedo programar una reunión con nuestro equipo de arquitectura ahora mismo.",
      waTitle: "Automatice ventas y atención al cliente en WhatsApp Business",
      waDesc: "Convierta los chats de WhatsApp en un canal de ventas automatizado. Envíe catálogos interactivos, cotizaciones en tiempo real y enlaces de reserva directamente en el chat.",
      waFeature1: "Integración oficial con la API Meta WhatsApp Business Cloud con verificación de tilde azul",
      waFeature2: "Envia tarjetas de productos interactivas, cotizaciones PDF y notas de voz",
      waFeature3: "Califica leads entrantes automáticamente según presupuesto, plazo y necesidad",
      waFeature4: "Programa reuniones directamente en Google Calendar sin salir de WhatsApp",
      waStat1: "TIEMPO RESPUESTA",
      waStat1Val: "< 1 Segundo",
      waStat2: "CONVERSIÓN",
      waStat2Val: "+45% Impulso",
      waStat3: "DISPONIBILIDAD",
      waStat3Val: "24/7 Automático",
      waBoxHeader: "FLUJO DE CHAT WHATSAPP EN VIVO",
      waBoxStatus: "API OFICIAL META",
      waSender: "Cliente:",
      waBody: "¿Tienen disponibilidad para una implementación de software este mes?",
      waBookedLabel: "Cita Agendada:",
      waBookedVal: "Mañana a las 10:00 AM",
      waLeadLabel: "Calificación Lead:",
      waLeadVal: "Alta Prioridad (A+)",
      emailTitle: "Cero retrasos en la bandeja de entrada: Respuesta y clasificación automática",
      emailDesc: "Responda a las consultas por correo electrónico en segundos. Nuestra IA analiza la intención, redacta respuestas personalizadas con información de su empresa y sincroniza cada correo con su CRM.",
      emailFeature1: "Clasifica correos según urgencia, intención de compra y tipo de consulta",
      emailFeature2: "Redacta respuestas humanas personalizadas usando la documentación de su empresa",
      emailFeature3: "Sincroniza correos con HubSpot, Salesforce y Zoho automáticamente",
      emailFeature4: "Notifica al instante al equipo de ventas por Slack o Teams ante leads de alto valor",
      emailStat1: "DEMORA BANDEJA",
      emailStat1Val: "0 Minutos",
      emailStat2: "TIEMPO AHORRADO",
      emailStat2Val: "15+ Horas/Sem",
      emailStat3: "PRECISIÓN",
      emailStat3Val: "99.2%",
      emailBoxHeader: "MOTOR DE CLASIFICACIÓN DE CORREO",
      emailBoxStatus: "0 MIN DE RETRASO",
      emailFrom: "De: director@enterprise.com",
      emailTime: "Justo ahora",
      emailSubject: "Asunto: Consulta sobre implementación de IA personalizada",
      emailBody: "\"Buscamos automatizar las llamadas telefónicas entrantes y la clasificación de correos para nuestros 50+ ejecutivos de ventas.\"",
      emailStep1: "1. Intención Clasificada",
      emailStep2: "2. Conocimiento Sintetizado",
      emailStep3: "3. Calendario Vinculado",
      emailReplyTitle: "RESPUESTA AUTOMÁTICA GENERADA",
      emailReplyBody: "\"¡Hola Director! Según el tamaño de su equipo, nuestra Arquitectura Enterprise se adapta perfectamente. He reservado un espacio estratégico a continuación.\"",
      emailIntentLabel: "Intención Compra:",
      emailIntentVal: "Alta (98/100)",
      emailRoutedLabel: "Rapeado a:",
      emailRoutedVal: "HubSpot + Slack",
      omniTitle: "Sin entrada manual: CRM bidireccional y orquestación de procesos",
      omniDesc: "Unifique cada llamada, conversación de WhatsApp y correo en su CRM principal. Crea contactos, actualice oportunidades de negocio y active seguimientos automatizados sin trabajo manual.",
      omniFeature1: "50+ integraciones nativas: HubSpot, Salesforce, Zoho, Google Sheets, Slack, Zapier",
      omniFeature2: "Pipelines de webhooks en tiempo real para bases de datos SQL y ERPs internos",
      omniFeature3: "Campañas automáticas de seguimiento por SMS y WhatsApp tras cada interacción",
      omniFeature4: "Notificaciones instantáneas al equipo en Slack, Microsoft Teams y SMS",
      omniStat1: "CONECTORES",
      omniStat1Val: "50+ Nativos",
      omniStat2: "SYNC DATOS",
      omniStat2Val: "Tiempo Real (0s)",
      omniStat3: "ERRORES",
      omniStat3Val: "0% Manual",
      omniBoxHeader: "PIPELINE DE SINCRONIZACIÓN BIDIRECCIONAL",
      omniBoxStatus: "TRANSMISIÓN EN VIVO",
      omniStep1Title: "Llamada / Chat de WhatsApp Finalizado",
      omniStep1Tag: "Disparador",
      omniStep2Title: "Transcripción y Análisis de Sentimiento IA",
      omniStep2Tag: "Procesando",
      omniStep3Title: "Oportunidad Creada y Asignada en HubSpot",
      omniStep3Tag: "Sincronizado (0s)",
      omniCrmList: "CRMs Soportados: HubSpot, Salesforce, Zoho, Google Sheets",
      supportTitle: "Mesa de ayuda y soporte al cliente autónomo 24/7",
      supportDesc: "Deleite a sus clientes con respuestas instantáneas 24/7 a preguntas frecuentes, estado de pedidos y facturación. Reduzca costos operativos de soporte hasta un 70% aumentando el CSAT.",
      supportFeature1: "Resuelve más del 80% de consultas de soporte nivel 1 sin intervención humana",
      supportFeature2: "Integrado con Shopify, Zendesk, Intercom y bases de conocimiento personalizadas",
      supportFeature3: "Escalamiento inteligente a ejecutivos humanos con resumen de contexto completo",
      supportFeature4: "Fluidez multilingüe en más de 50 idiomas globales para alcance internacional",
      supportStat1: "RESUELTOS",
      supportStat1Val: "80%+ Instantáneo",
      supportStat2: "AHORROS",
      supportStat2Val: "Hasta un 70%",
      supportStat3: "CSAT",
      supportStat3Val: "98.7%",
      supportBoxHeader: "RESOLUCIÓN DE TICKET DE SOPORTE",
      supportBoxStatus: "AUTÓNOMO",
      supportQueryLabel: "Consulta de Cliente:",
      supportQueryVal: "\"¿Dónde está mi pedido #TR-8492 y puedo actualizar mi dirección de envío?\"",
      supportResLabel: "Resolución IA (< 1s):",
      supportResVal: "\"¡El pedido #TR-8492 está en camino! Dirección actualizada en Shopify y confirmación enviada por SMS.\"",
      supportLangLabel: "Idiomas:",
      supportLangVal: "50+ Soportados",
      supportStatusLabel: "Estado Ticket:",
      supportStatusVal: "Resuelto",
      roiTag: "ESTIMADOR DE RECUPERACIÓN DE INGRESOS",
      roiTitle: "Calcule su recuperación mensual de ingresos entrantes",
      roiSub: "Vea cuántos ingresos recupera un agente de IA autónomo capturando llamadas perdidas e inquietudes al instante.",
      roiLabelInquiries: "Consultas Entrantes Mensuales",
      roiLabelDealValue: "Valor Promedio del Cliente ($)",
      roiLabelMissedRate: "Proporción Estimada de Leads Perdidos (%)",
      roiStatLeads: "LEADS CAPTURADOS",
      roiStatLeadsUnit: "Consultas / Mes",
      roiStatHours: "HORAS AHORRADAS",
      roiStatHoursUnit: "Tiempo Personal / Mes",
      roiStatRevenue: "INGRESOS RECUPERADOS EST.",
      roiStatRevenueUnit: "Recuperado / Mes",
      faqTag: "PREGUNTAS FRECUENTES",
      faqTitle: "Preguntas Frecuentes sobre Automatizaciones e IA",
      faqQ1: "¿Cómo maneja un Agente de Voz IA autónomo las llamadas telefónicas de una empresa?",
      faqA1: "Un Agente de Voz IA utiliza síntesis de voz de ultra baja latencia (<280ms) y modelos de lenguaje para conversar de forma natural. Responde preguntas frecuentes, revisa calendarios de personal (Google Workspace/Outlook), reserva citas y transfiere llamadas prioritarias.",
      faqQ2: "¿Cuál es la ventaja de velocidad al responder clientes potenciales?",
      faqA2: "Contactar a un cliente potencial en menos de 60 segundos genera una tasa de conversión un 391% mayor comparada con una demora de 30 minutos. Nuestro ecosistema de IA responde al instante (<1 segundo) por teléfono, WhatsApp y correo.",
      faqQ3: "¿Pueden los Asistentes de IA en WhatsApp enviar catálogos PDF y agendar reuniones?",
      faqA3: "¡Sí! Utilizando la API oficial de Meta WhatsApp Business Cloud, nuestros asistentes entregan tarjetas interactivas, cotizaciones, notas de voz y widgets de reserva de calendario dentro del chat.",
      faqQ4: "¿Cómo se sincroniza el Motor de Automatización con CRMs como HubSpot, Salesforce y Zoho?",
      faqA4: "El sistema opera mediante webhooks bidireccionales en tiempo real e integraciones API REST. Cada transcripción de llamada, grabación, chat de WhatsApp y correo se registra automáticamente en su CRM.",
      faqQ5: "¿Están seguros y protegidos los datos de los clientes?",
      faqA5: "El tránsito de datos está encriptado con TLS 1.3 de nivel empresarial y cifrado AES-256 en reposo. Cumple con los estándares SOC-2 Type II, HIPAA y GDPR. Sus datos nunca se usan para entrenar modelos públicos.",
      faqQ6: "¿Qué tan rápido se puede desplegar un motor de IA para mi empresa?",
      faqA6: "El despliegue toma menos de 48 horas. Nuestro equipo de ingeniería absorbe su documentación existente, conecta sus números de teléfono y APIs de CRM, realiza pruebas y lanza su sistema autónomo 24/7.",
      ctaTag: "DESPLIEGUE EN 48 HORAS",
      ctaTitle: "¿Listo para automatizar sus operaciones entrantes?",
      ctaSub: "Despliegue agentes de voz e IA personalizados entrenados con la documentación de su empresa en menos de 48 horas.",
      ctaBtnPrimary: "Reservar Auditoría de Arquitectura IA"
    }
  },
  fr: {
    navbar: {
      services: "Services",
      aboutCompany: "Sur l'Entreprise",
      leadership: "Direction",
      blog: "Chroniques",
      caseStudies: "Cas de Succès",
      proptech: "SaaS PropTech"
    },
    services: {
      dedicatedPartnerHeader: "Votre partenaire dédié pour",
      alternatingKeywords: ["SaaS de Santé", "SaaS de RH", "SaaS de Construction", "SaaS de Logistique"],
      tag: "Services sur Mesure / Croissance d'Entreprise",
      title: "Nos Services d'Ingénierie & de Développement Personnalisés",
      desc: "Nous ne créons pas seulement nos propres produits SaaS ; nous nous associons avec des clients potentiels et des entreprises modernes pour concevoir, structurer et déployer des solutions logicielles d'exception.",
      b1Tag: "SaaS & Applications",
      b1Title: "Ingénierie Logicielle Full-Stack",
      b1Desc: "Applications web personnalisées, plateformes SaaS robustes et applications mobiles haute performance avec une sécurité de typage absolue et des chargements instantanés.",
      b2Tag: "Design Systems & UI",
      b2Title: "UX Tactile & Interfaces Animées",
      b2Desc: "Mises en page vectorielles interactives, esthétique premium à fort contraste et transitions fluides (motion/react) pour maximiser l'engagement des utilisateurs.",
      b3Tag: "Cloud & Sécurité",
      b3Title: "Base de Données Sécurisée & Scaling Cloud",
      b3Desc: "Structures de tables relationnelles optimisées, intégrations sur mesure et pare-feux sécurisés avec validation dynamique des adresses IP des clients.",
      b4Tag: "Stratégie & SEO Premium",
      b4Title: "Référencement International & Performance",
      b4Desc: "Schémas JSON-LD prêts pour le crawl des robots, fils d'Ariane automatisés, synchronisation des métadonnées et support multilingue natif pour une visibilité mondiale.",
      guaranteeTitle: "Prêt à concevoir votre plateforme sur mesure avec Teralumax ?",
      guaranteeDesc: "Chaque projet bénéficie de nos garanties de performance de niveau production : vitesse de chargement ultra-rapide, design adaptatif, infrastructure cloud robuste et indexation SEO optimale."
    },
    footer: {
      desc: "Nous concevons, codons et déployons des produits élégants et des interfaces cloud légères pour les startups numériques.",
      productsHeader: "Portefeuille de Produits",
      companyHeader: "Nœud d'Entreprise",
      documentation: "Documentation",
      contact: "Contact",
      philosophy: "Nous concevons, codons et déployons des produits élégants et des interfaces cloud légères pour les startups numériques."
    },
    contact: {
      privacyText: "Connexion sécurisée cryptée SSL 256 bits.",
      anotherCta: "Envoyer un autre message"
    },
    aboutPage: {
      meta: "Profil de l'Entreprise",
      title: "Teralumax Private Limited",
      subtitle: "Incorporée le 22 novembre 2022",
      cin: "CIN / Numéro d'Identification d'Entreprise",
      cinValue: "U72900DL2022PTC407338",
      addressLabel: "Siège Social",
      addressValue: "Sec-5, Vaishali, Ghaziabad, Uttar Pradesh, Inde - 201010",
      statusLabel: "Statut d'Enregistrement",
      statusValue: "Actif (Société Privée Non Cotée Limitée par Actions)",
      domainLabel: "Domaine Numérique",
      domainValue: "Ingénierie Logicielle & Architectures de Produits",
      paragraph1: "Teralumax Private Limited est une entreprise technologique d'élite constituée le 22 novembre 2022. Travaillant à la convergence de l'ingénierie backend rigoureuse et de la précision esthétique, nous développons des produits logiciels modernes axés sur la vitesse, l'adaptabilité et la réactivité sensorielle.",
      paragraph2: "Qu'il s'agisse de réservations spatiales (Roomy™), de constructeurs de schémas relationnels (SiteForces), ou de puzzles néon géométriques (Arrow Escape sur le Google Play Store), Teralumax élimine les modèles standard complexes au profit de solutions uniques conçues à partir de principes fondamentaux.",
      statIncorporation: "Incorporation",
      statClass: "Catégorie",
      statClassVal: "Société Privée",
      statActive: "Statut du Registre",
      statActiveVal: "Actif / MCA"
    },
    leadershipPage: {
      meta: "Commandement Exécutif",
      title: "Conseil d'Administration",
      subtitle: "Les architectes qui tracent les lignes technologiques de Teralumax.",
      aboutAbhishek: "Abhishek Balu Vadave",
      roleAbhishek: "Fondateur & Directeur Général",
      bioAbhishek: "Abhishek Balu Vadave est le fondateur stratégique et le directeur artistique de Teralumax Private Limited. Passionné par les systèmes de type stricts et la typographie de précision, il conçoit les produits phares et programme les interfaces tactiles interactives, élevant le logiciel de qualité au rang d'art à part entière.",
      aboutBalu: "Balu Laxman Vadave",
      roleBalu: "Directeur de la Gouvernance",
      bioBalu: "Balu Laxman Vadave co-dirige la gouvernance de Teralumax, assurant la conformité juridique, la supervision financière et la résilience administrative afin de permettre aux équipes techniques d'innover continuellement et sans entrave.",
      missionTitle: "Philosophie d'Ingénierie",
      missionText: "Nous pensons que l'interface logicielle doit prolonger naturellement les facultés de l'esprit, sans friction. Nous imposons une structure modulaire stricte et un temps de réponse instantané."
    }
  },
  de: {
    navbar: {
      services: "Dienstleistungen",
      aboutCompany: "Über das Unternehmen",
      leadership: "Unternehmensleitung",
      blog: "Technische Chroniken",
      caseStudies: "Fallbeispiele",
      proptech: "PropTech SaaS"
    },
    services: {
      dedicatedPartnerHeader: "Ihr engagierter Partner für",
      alternatingKeywords: ["Medizin-SaaS", "HR-SaaS", "Bauwesen-SaaS", "Logistik-SaaS"],
      tag: "Maßgeschneiderte Dienste / Unternehmenswachstum",
      title: "Unsere maßgeschneiderten Entwicklungs- & Engineering-Leistungen",
      desc: "Wir bauen nicht nur eigene SaaS-Produkte. Wir arbeiten eng mit potenziellen Kunden und modernen Unternehmen zusammen, um erstklassige, maßgeschneiderte Softwarearchitekturen zu entwickeln.",
      b1Tag: "SaaS- & App-Entwicklung",
      b1Title: "Full-Stack Software Engineering",
      b1Desc: "Individuelle Webanwendungen, robuste SaaS-Plattformen und leistungsstarke mobile Apps mit absoluter Typsicherheit und subsekündlichen Ladezeiten.",
      b2Tag: "Design-Systems & UI",
      b2Title: "Haptische UX & Animations-Interfaces",
      b2Desc: "Interaktive Vektorlayouts, kontrastreiches Premium-Design und flüssige Animationen mit motion/react für ein elegantes Nutzererlebnis.",
      b3Tag: "Cloud- & Sicherheitsarchitektur",
      b3Title: "Sichere Datenbanken & Cloud-Skalierung",
      b3Desc: "Relationale Datenbankstrukturen, maßgeschneiderte Integrationen und robuste Firewalls mit dynamischer IP-Validierung für absolute Datensicherheit.",
      b4Tag: "Unternehmensstrategie & SEO",
      b4Title: "Erstklassiges SEO & High-Performance",
      b4Desc: "Suchmaschinenoptimiertes JSON-LD Schema, automatisierte Breadcrumbs, Meta-Synchronisation und multilingualer Support für maximale globale Reichweite.",
      guaranteeTitle: "Bereit für ein maßgeschneidertes Projekt mit Teralumax?",
      guaranteeDesc: "Jede Zusammenarbeit umfasst umfassende Performance-Garantien: Ladezeiten unter einer Sekunde, pixelgenaues Layout, skalierbare Cloud-Infrastruktur und Premium-SEO."
    },
    footer: {
      desc: "Wir entwerfen, entwickeln und implementieren leichte, elegante Softwarelösungen und Cloud-Produkte für innovative Start-ups.",
      productsHeader: "Produktportfolio",
      companyHeader: "Unternehmensknoten",
      documentation: "Dokumentation",
      contact: "Kontakt",
      philosophy: "Wir entwerfen, entwickeln und implementieren leichte, elegante Softwarelösungen und Cloud-Produkte für innovative Start-ups."
    },
    contact: {
      privacyText: "Sichere 256-Bit SSL-verschlüsselte Verbindung.",
      anotherCta: "Weitere Nachricht senden"
    },
    aboutPage: {
      meta: "Unternehmensprofil",
      title: "Teralumax Private Limited",
      subtitle: "Eingetragen am 22. November 2022",
      cin: "CIN / Handelsregisternummer",
      cinValue: "U72900DL2022PTC407338",
      addressLabel: "Eingetragener Firmensitz",
      addressValue: "Sec-5, Vaishali, Ghaziabad, Uttar Pradesh, Indien - 201010",
      statusLabel: "Registrierungsstatus",
      statusValue: "Aktiv (Nicht börsennotierte private Aktiengesellschaft)",
      domainLabel: "Digitaler Fokus",
      domainValue: "Softwareentwicklung & innovative Produktarchitekturen",
      paragraph1: "Teralumax Private Limited ist ein am 22. November 2022 gegründetes Softwareunternehmen. An der Schnittstelle von robuster Backend-Architektur und visuellem UI-Design entwickeln wir maßgeschneiderte Softwareprodukte mit dem Fokus auf extreme Leistung und intuitive Handhabung.",
      paragraph2: "Von Echtzeit-Raumbuchungssystemen (Roomy™) über schemabasierte Web-Editoren (SiteForces) bis hin zu rasanten Logikspielen (Arrow Escape im Google Play Store) setzen wir konsequent auf eigenständige Cloud-Strukturen, die von Grund auf neu erdacht werden.",
      statIncorporation: "Gründung",
      statClass: "Unternehmensart",
      statClassVal: "Private Ltd",
      statActive: "Status",
      statActiveVal: "Aktiv / MCA"
    },
    leadershipPage: {
      meta: "Führungsebene",
      title: "Aufsichtsrat & Führung",
      subtitle: "Die Visionäre hinter der technologischen Identität von Teralumax.",
      aboutAbhishek: "Abhishek Balu Vadave",
      roleAbhishek: "Gründer & Geschäftsführer",
      bioAbhishek: "Abhishek Balu Vadave ist der Gründer und führende Kopf hinter Teralumax Private Limited. Mit einem ausgeprägten Sinn für mathematische Präzision und minimalistische Ästhetik leitet er die gesamte technische Produktplanung. Er setzt Maßstäbe in Sachen Code-Qualität, Typsicherheit und flüssige Steuerungsschleifen.",
      aboutBalu: "Balu Laxman Vadave",
      roleBalu: "Director of Governance",
      bioBalu: "Balu Laxman Vadave unterstützt Teralumax als Co-Direktor für Finanzen, Regulierungsangelegenheiten und Compliance. Durch sein fundiertes Management schafft er stabile Rahmenbedingungen für ungestörte technologische Innovationen.",
      missionTitle: "Unsere Leitlinien",
      missionText: "Software sollte sich nahtlos in den Alltag einfügen. Jedes von uns entwickelte Produkt basiert auf geringem Ressourcenverbrauch, maximaler Modularität und außergewöhnlicher Schnelligkeit."
    }
  },
  hi: {
    navbar: {
      services: "सेवाएं",
      aboutCompany: "कंपनी के बारे में",
      leadership: "नेतृत्व",
      blog: "तकनीकी इतिहास",
      caseStudies: "सफलता की कहानियां",
      proptech: "प्रॉपटेक SaaS"
    },
    services: {
      dedicatedPartnerHeader: "आपका समर्पित भागीदार",
      alternatingKeywords: ["हेल्थकेयर SaaS", "एचआर SaaS", "कंस्ट्रक्शन SaaS", "लॉजिस्टिक्स SaaS"],
      tag: "कस्टम उत्पाद सेवाएं / कॉर्पोरेट विकास",
      title: "हमारी कस्टम इंजीनियरिंग और विकास सेवाएं",
      desc: "हम केवल अपने ही SaaS उत्पाद नहीं बनाते; हम संभावित ग्राहकों और आधुनिक व्यवसायों के साथ जुड़कर उनके लिए विश्व स्तरीय कस्टम सॉफ़्टवेयर समाधान डिज़ाइन, कोड और तैनात करते हैं।",
      b1Tag: "SaaS और ऐप विकास",
      b1Title: "पूर्ण-स्टैक सॉफ्टवेयर इंजीनियरिंग",
      b1Desc: "कस्टम वेब ऐप्स, मजबूत SaaS प्लेटफॉर्म और उच्च प्रदर्शन वाले मोबाइल ऐप्स पूर्ण टाइप-सुरक्षा, अत्यधिक तीव्र डेटा प्रवाह और न्यूनतम लोडिंग समय के साथ।",
      b2Tag: "डिजाइन सिस्टम और UI",
      b2Title: "संवेदी UX और गतिशील इंटरफेस",
      b2Desc: "इंटरैक्टिव वक्र लेआउट, शानदार उच्च-विपरीत सौंदर्यबोध और motion/react के साथ निर्मित सहज एनिमेशन जो उपयोगकर्ता जुड़ाव को बढ़ाते हैं।",
      b3Tag: "क्लाउड और सुरक्षा वास्तुकला",
      b3Title: "सुरक्षित डेटाबेस और क्लाउड स्केलिंग",
      b3Desc: "रिलेशनल डेटाबेस संरचनाएं, अनुकूलित क्लाउड-नेटिव इंस्टेंस और क्लाइंट IP प्रमाणीकरण वाले मजबूत फ़ायरवॉल आपके सॉफ़्टवेयर कोर की सुरक्षा के लिए।",
      b4Tag: "कॉर्पोरेट रणनीति और SEO",
      b4Title: "वैश्विक स्तर का SEO और इष्टतम गति",
      b4Desc: "खोज इंजन के अनुकूल JSON-LD स्कीमा, स्वचालित ब्रेडक्रंब, मेटा प्रलेखन और वैश्विक स्तर पर अधिकतम दृश्यता के लिए बहुभाषी समर्थन।",
      guaranteeTitle: "सॉफ़्टवेयर परियोजना के लिए तैयार हैं?",
      guaranteeDesc: "हमारा प्रत्येक प्रोजेक्ट उच्च प्रदर्शन की गारंटी देता है: 1 सेकंड से कम का लोडिंग समय, उत्तरदायी डिज़ाइन, मजबूत क्लाउड इंफ्रास्ट्रक्चर और विश्व स्तरीय SEO।"
    },
    footer: {
      desc: "हम दुनिया भर के डिजिटल स्टार्टअप्स के लिए हल्के, सुंदर सॉफ्टवेयर प्रोजेक्ट्स और क्लाउड इंटरफेस का निर्माण और डिज़ाइन करते हैं।",
      productsHeader: "उत्पाद पोर्टफोलियो",
      companyHeader: "कंपनी नोड",
      documentation: "दस्तावेज़",
      contact: "संपर्क",
      philosophy: "हम दुनिया भर के डिजिटल स्टार्टअप्स के लिए हल्के, सुंदर सॉफ्टवेयर प्रोजेक्ट्स और क्लाउड इंटरफेस का निर्माण और डिज़ाइन करते हैं।"
    },
    contact: {
      privacyText: "सुरक्षित 256-बिट एसएसएल एन्क्रिप्टेड कनेक्शन।",
      anotherCta: "दूसरा संदेश भेजें"
    },
    aboutPage: {
      meta: "कॉर्पोरेट विवरण",
      title: "टेराल्यूमैक्स प्राइवेट लिमिटेड",
      subtitle: "स्थापना 22 नवंबर, 2022",
      cin: "सीआईएन / कॉर्पोरेट नंबर",
      cinValue: "U72900DL2022PTC407338",
      addressLabel: "पंजीकृत कार्यालय पता",
      addressValue: "सेक्टर-5, वैशाली, गाजियाबाद, उत्तर प्रदेश, भारत - 201010",
      statusLabel: "पंजीकरण की स्थिति",
      statusValue: "सक्रिय (शेयरों द्वारा सीमित असूचीबद्ध निजी कंपनी)",
      domainLabel: "डिजिटल डोमेन",
      domainValue: "सॉफ़्टवेयर इंजीनियरिंग और डिजिटल उत्पाद आर्किटेक्चर",
      paragraph1: "टेराल्यूमैक्स प्राइवेट लिमिटेड (Teralumax Private Limited) 22 नवंबर, 2022 को पंजीकृत एक उत्कृष्ट भारतीय सॉफ़्टवेयर विकास संस्था है। हम उन्नत तकनीकी आर्किटेक्चर और दृश्य डिजाइन की शुद्धता के समन्वय से कार्य करते हैं, जिससे उपयोग में आसान और प्रतिक्रियाशील उत्पाद विकसित हो सकें।",
      paragraph2: "कार्यक्षेत्र प्रबंधन (Roomy™) और रिलेशनल डेटाबेस चालित वेबसाइट विकास (SiteForces) से लेकर मोबाइल पहेली खेल (Arrow Escape Google Play Store पर उपलब्ध) तक, टेराल्यूमैक्स तकनीकी मापदंडों को खड़ा करने और टेम्प्लेट के स्थान पर मूल सिद्धांतों से काम करने के लिए समर्पित है।",
      statIncorporation: "स्थापना वर्ष",
      statClass: "कंपनी की श्रेणी",
      statClassVal: "निजी लिमिटेड",
      statActive: "वर्तमान स्थिति",
      statActiveVal: "सक्रिय / MCA"
    },
    leadershipPage: {
      meta: "प्रशासनिक दृष्टिकोण",
      title: "निदेशक मंडल",
      subtitle: "वे रचनाकार जो टेराल्यूमैक्स के भविष्य की दिशा तय करते हैं।",
      aboutAbhishek: "अभिषेक बालू वडवे",
      roleAbhishek: "संस्थापक और प्रबंध निदेशक",
      bioAbhishek: "अभिषेक बालू वडवे (Abhishek Balu Vadave) टेराल्यूमैक्स प्राइवेट लिमिटेड के संस्थापक और मुख्य रणनीतिकार हैं। वह कंपनी के सॉफ्टवेयर दर्शन, कोर आर्किटेक्चर और डिज़ाइन नीतियों के प्रदाता हैं। उनके नेतृत्व में, कंपनी कड़ी कोडिंग स्वच्छता, टाइप-सुरक्षा और गति संवेदी सूक्ष्म-एनिमेशन को विशेष महत्व देती है ताकि डिजिटल दुनिया में वास्तविक कारीगरी स्थापित हो सके।",
      aboutBalu: "बालू लक्ष्मण वडवे",
      roleBalu: "निदेशक (शासन एवं योजना)",
      bioBalu: "बालू लक्ष्मण वडवे टेराल्यूमैक्स निदेशक मंडल में सह-निदेशक हैं। वह रणनीतिक शासन, कॉर्पोरेट अनुपालन, सरकारी वित्तीय प्रलेखन और परिचालन स्थिरता की ज़िम्मेदारी संभालते हैं, जिससे तकनीकी टीम निर्बाध और सुरक्षित रूप से नवाचार कर सके।",
      missionTitle: "हमारा दर्शन",
      missionText: "हमारा मानना है कि सॉफ्टवेयर जटिलताओं को दूर करने का एक सहज साधन होना चाहिए। हम अपने उत्पादों में कम डेटा लोड, अत्यधिक लचीलेपन और त्वरित संवाद पर जोर देते हैं।"
    }
  },
  zh: {
    navbar: {
      services: "专业服务",
      aboutCompany: "关于公司",
      leadership: "领导团队",
      blog: "技术志",
      caseStudies: "成功案例",
      proptech: "智能房产 SaaS"
    },
    services: {
      dedicatedPartnerHeader: "您专属的合作伙伴，专注于",
      alternatingKeywords: ["医疗健康 SaaS", "人力资源 SaaS", "建筑工程 SaaS", "智能物流 SaaS"],
      tag: "定制化开发服务 / 企业高效增长",
      title: "我们领先的定制系统工程与技术开发服务",
      desc: "我们不仅自主研发现代化 SaaS 产品，更深度赋能潜在客户与全球企业，为其设计、打磨、部署世界一流的定制化软件高阶架构。",
      b1Tag: "SaaS & 移动研发",
      b1Title: "全栈软件工程开发",
      b1Desc: "定制 Web 系统、高鲁棒性 SaaS 平台及高性能原生 App，实施极严苛类型安全规范、瞬时数据流及极致加载响应。",
      b2Tag: "设计系统 & UI 美学",
      b2Title: "触觉级 UX 与微交互动效",
      b2Desc: "精雕细琢的交互矢量界面、高对比度奢华美学以及基于 motion/react 的丝滑运镜过渡，借溢价质感显著提振留存率。",
      b3Tag: "云原生 & 安全保障",
      b3Title: "高防安全数据库与云端弹性伸缩",
      b3Desc: "稳如磐石的关系型表模型设计、专设私有云环境，配备基于客户端 IP 分布式动态防火墙校验，护航业务核心数据安全。",
      b4Tag: "企业战略 & 行业级 SEO",
      b4Title: "世界一流 SEO 排名优化与强性能",
      b4Desc: "全面配备利于网络爬虫解析的 JSON-LD 数据图谱、全域自动化面包屑导航、多语种动态路由及元数据同步，打造全网领跑的自然流量入口。",
      guaranteeTitle: "准备好与 Teralumax 携手开启定制化项目了吗？",
      guaranteeDesc: "我们对每一次技术协作承诺最高标品控保障：秒级网页加载响应、多端自适应布局、高危云防火墙部署以及高额搜索引擎曝光收录。"
    },
    footer: {
      desc: "我们为全球数字化原生创业企业设计、编写和部署高性能的轻量级优雅软件产品和云端界面。",
      productsHeader: "产品组合",
      companyHeader: "公司核心",
      documentation: "平台文档",
      contact: "联系我们",
      philosophy: "我们为全球数字化原生创业企业设计、编写和部署高性能的轻量级优雅软件产品 and 云端界面。"
    },
    contact: {
      privacyText: "安全 256 位 SSL 加密传输连接。",
      anotherCta: "发送另一条信息"
    },
    aboutPage: {
      meta: "企业形象",
      title: "Teralumax Private Limited",
      subtitle: "成立于 2022 年 11 月 22 日",
      cin: "CIN / 公司注册识别号",
      cinValue: "U72900DL2022PTC407338",
      addressLabel: "注册办公地址",
      addressValue: "印度北方邦加济阿巴德外沙利 5 区，邮编 201010",
      statusLabel: "注册状态",
      statusValue: "活跃（非上市股份限制性私营有限公司）",
      domainLabel: "技术领域",
      domainValue: "软件工程与卓越数字产品架构",
      paragraph1: "Teralumax Private Limited 是一家成立于 2022 年 11 月 22 日的高端软件开发企业。我们致力于结构工程和极简布局美学的融合，旨在取代千篇一律的通用模板，为您打磨性能至上、富有触感和动效微反馈的优雅系统。",
      paragraph2: "无论是基于云原生的智能办公位调度系统（Roomy™）、结合关系型数据库的无代码建站工具（SiteForces），还是在 Google Play 商店发售的几何益智类手游（Arrow Escape），Teralumax 始终坚持从第一性原理出发，绝不在代码性能上做任何妥协。",
      statIncorporation: "成立时间",
      statClass: "企业类型",
      statClassVal: "私营有限公司",
      statActive: "存续状态",
      statActiveVal: "MCA 活跃注册"
    },
    leadershipPage: {
      meta: "核心管理层",
      title: "董事会成员",
      subtitle: "指引 Teralumax 技术版图与前行路线的架构师。",
      aboutAbhishek: "Abhishek Balu Vadave",
      roleAbhishek: "创始人兼常务董事",
      bioAbhishek: "Abhishek Balu Vadave 是 Teralumax Private Limited 的创意掌舵人与技术灵魂。作为创始人，他主导了所有的核心产品规划与交互设计。得益于他在计算机逻辑与排版美学领域的求索，Teralumax 建立了极为苛刻的代码卫生态、类型严谨度与流畅的极速操作响应规范，将软件赋予艺术品的品格。",
      aboutBalu: "Balu Laxman Vadave",
      roleBalu: "合伙董事兼合规总监",
      bioBalu: "Balu Laxman Vadave 是 Teralumax 董事会的合伙成员，负责公司的日常财务、法律法规审计以及内部运营调度。他的稳健治理为技术团队开辟了专注性能研发的前端净土。",
      missionTitle: "工程哲学",
      missionText: "人机交互应当是直觉且无感的。为此，我们对所有项目执行最高阶的模块化解耦标准、压缩数据负荷，以此打造坚如磐石的用户体验。"
    }
  },
  ja: {
    navbar: {
      services: "提供サービス",
      aboutCompany: "会社概要",
      leadership: "リーダーシップ",
      blog: "技術クロニクル",
      caseStudies: "成功事例",
      proptech: "不動産テック SaaS"
    },
    services: {
      dedicatedPartnerHeader: "以下に特化した、信頼できる開発パートナー",
      alternatingKeywords: ["医療系 SaaS", "人事・労務 SaaS", "建設・不動産 SaaS", "物流・ロジスティクス SaaS"],
      tag: "テーラーメイド開発 / 企業成長 of 最大化",
      title: "オーダーメイド型エンジニアリング＆開発サービス",
      desc: "高度な自社SaaS製品の展開に留まらず、国内外のクライアントや現代の企業と連携し、最高クラスのカスタムソフトウェアソリューションの設計、構築、展開をサポートします。",
      b1Tag: "SaaS & アプリ開発",
      b1Title: "フルスタック・ソフトウェア開発",
      b1Desc: "万全の型安全、超高速なデータ処理、驚異的なローディングスピードを備えたカスタムWebアプリケーション、本格的なSaaS、ネイティブモバイル製品を開発します。",
      b2Tag: "デザインシステム & UI",
      b2Title: "タクタイルUX ＆ インタラクティブアニメーション",
      b2Desc: "高品質な高コントラストデザイン、洗練されたベクターレイアウト、motion/reactを駆使したなめらかな状態遷移により、ユーザーのエンゲージメントを極限まで高めます。",
      b3Tag: "クラウド ＆ セキュリティ設計",
      b3Title: "セキュアデータベース ＆ クラウドスケーリング",
      b3Desc: "リレーショナル表設計、最適なクラウド構築、クライアントIP検証型ファイアウォールなどのリアルタイムセキュリティ対策により、貴重なシステムコアを保護します。",
      b4Tag: "エンタープライズ戦略 ＆ SEO",
      b4Title: "世界基準のSEO ＆ ハイパフォーマンス",
      b4Desc: "検索クローラーフレンドリーなJSON-LD構造化データ、自動生成パンくずリスト、複数言語マルチルーティング処理、メタタグ即時更新により高い検索エンジン露出を実現します。",
      guaranteeTitle: "Teralumaxと最高峰のカスタムシステムを構築しませんか？",
      guaranteeDesc: "すべての共同開発プロジェクトに最高品質の基準：1秒未満のロード時間、最新鋭レスポンシブデザイン、堅牢なクラウド構成、プレミアムSEO対策をすべて標準適用します。"
    },
    footer: {
      desc: "私たちは、グローバルなデジタルスタートアップ向けに、軽量でエレガントなWeb製品とクラウドインターフェースを開発・展開しています。",
      productsHeader: "製品ラインナップ",
      companyHeader: "会社運営ノード",
      documentation: "ドキュメント",
      contact: "お問い合わせ",
      philosophy: "私たちは、グローバルなデジタルスタートアップ向けに、軽量でエレガントなWeb製品とクラウドインターフェースを開発・展開しています。"
    },
    contact: {
      privacyText: "安全な256ビットSSL暗号化接続がアクティブです。",
      anotherCta: "別のメッセージを送信"
    },
    aboutPage: {
      meta: "コーポレート・プロファイル",
      title: "Teralumax Private Limited",
      subtitle: "2022年11月22日設立",
      cin: "CIN / 企業識別番号",
      cinValue: "U72900DL2022PTC407338",
      addressLabel: "本店登記住所",
      addressValue: "インド、ウッタル・プラデーシュ州ガーズィヤーバード、ヴァイシャリ セクター5 - 201010",
      statusLabel: "登記ステータス",
      statusValue: "アクティブ（株式所有制限付き非上場民間企業）",
      domainLabel: "デジタル事業領域",
      domainValue: "ソフトウェアエンジニアリング & デジタル製品設計",
      paragraph1: "Teralumax Private Limitedは、2022年11月22日に設立された先進のソフトウェア開発システム企業です。堅牢なバックエンドアーキテクチャと精密なUIデザインの完璧な調和を追求し、テンプレートでは不可能な最高水準のインタラクティブ体験を提供します。",
      paragraph2: "クラウド型ルーム予約システム（Roomy™）から、リレーショナル設計Webビルダー（SiteForces）、Google Playストアで展開中のパズルモバイルゲーム（Arrow Escape）に至るまで、Teralumaxは第一原理からプロダクトを構築し、徹底した品質保護にこだわり抜いています。",
      statIncorporation: "設立年",
      statClass: "企業区分",
      statClassVal: "民間非上場",
      statActive: "登記状況",
      statActiveVal: "MCA登録済"
    },
    leadershipPage: {
      meta: "エグゼクティブ・コマンド",
      title: "取締役会",
      subtitle: "Teralumax の技術進路を牽引するフロント・アーキテクト。",
      aboutAbhishek: "Abhishek Balu Vadave",
      roleAbhishek: "創業者 & 代表取締役",
      bioAbhishek: "Abhishek Balu Vadaveは、Teralumax Private Limitedの創設者でありクリエイティブ責任者です。計算論的論理と美しいタイポグラフィに基づき、高品質な製品創出を率いています。コード의 위생상태와 타입 안정성을 중요시하며, 공예품으로서의 완벽성을 추구합니다.",
      aboutBalu: "Balu Laxman Vadave",
      roleBalu: "共同取締役・統治総監",
      bioBalu: "Balu Laxman Vadaveは、Teralumaxの共同取締役です。法律・税務、企業ガバナンス、強固な経営戦略の策定を担当し、エンジニアリンググループが技術開発に全力を注げる環境を支援しています。",
      missionTitle: "私たちの開発思想",
      missionText: "ソフトウェアは人間の生産性を拡張する、最も直感的なパートナーであるべきです。データの軽量化と、瞬間のレスポンスを妥協なく追求します。"
    }
  },
  ar: {
    navbar: {
      services: "الخدمات الإضافية",
      aboutCompany: "عن الشركة",
      leadership: "القيادة",
      blog: "السجلات التقنية",
      caseStudies: "دراسات إيجابية",
      proptech: "منصة برمجيات العقار"
    },
    services: {
      dedicatedPartnerHeader: "شريكك المخصص لـ",
      alternatingKeywords: ["برمجيات الرعاية الصحية", "برمجيات الموارد البشرية", "برمجيات البناء والتشييد", "برمجيات الخدمات اللوجستية"],
      tag: "خدمات مخصصة / نمو الشركات الرائدة",
      title: "خدماتنا المخصصة في الهندسة البرمجية والتطوير والنمو",
      desc: "نحن لا نكتفي ببناء منصات SaaS الخاصة بنا فقط؛ بل نتعاون في شراكات إستراتيجية مع عملائنا المستهدفين لتصميم وتطوير ونشر حلول برمجية مخصصة وعالمية المستوى.",
      b1Tag: "تطوير SaaS والتطبيقات",
      b1Title: "هندسة البرمجيات المتكاملة والكاملة",
      b1Desc: "تطبيقات الويب المخصصة، ومنصات SaaS القوية، والتطبيقات المحمولة عالية الأداء؛ المبنية مع حماية برمجية متكاملة وقنوات بيانات فائقة السرعة ولود فوري.",
      b2Tag: "أنظمة التصميم وواجهة المستخدم",
      b2Title: "تصميم تجربة المستخدم التفاعلية والحركية",
      b2Desc: "تكوينات متجهة وتفاعلية، وجماليات معمارية فاخرة وعالية التباين، وانتقالات سلسلة باستخدام motion/react تزيد من ولاء المستخدم النهائي للتطبيق.",
      b3Tag: "هندسة السحاب والأمان",
      b3Title: "قاعدة بيانات آمنة وتوسيع نطاق السحاب التلقائي",
      b3Desc: "بناء هياكل الجداول العلائقية بكفاءة، وربطها مباشرة بقواعد البيانات الآمنة، مع تفعيل جدار حماية ذكي للتحقق من هوية IP للعميل لحماية الكيان البرمجي.",
      b4Tag: "إستراتيجيات الشركات وSEO",
      b4Title: "الظهور الرقمي العالمي وضمان السرعة القصوى",
      b4Desc: "مخططات JSON-LD Schema جاهزة للزحف، وآلية مسارات التنقل الآلية، وترتيبات لغات متعددة توفر لك ظهورًا عالميًا رائدًا وتصنيف محركات البحث الأول.",
      guaranteeTitle: "جاهز لتصميم منصة تكنولوجية مخصصة مع تيرالوماكس؟",
      guaranteeDesc: "تعمل كل شراكة معنا تحت معايير أداء فائقة: سرعات تحميل تحت الثانية، وتنسيق ملاءمة متعدد الشاشات، وإشراف على البنية التحتية، وتهيئة SEO رقمية ممتازة."
    },
    footer: {
      desc: "نقوم بتصميم وبرمجة ونشر منتجات برمجية خفيفة الوزن وواجهات سحابية أنيقة للشركات الناشئة كافّة.",
      productsHeader: "محفظة المنتجات",
      companyHeader: "عقدة المؤسسة",
      documentation: "وثائق تقنية",
      contact: "اتصل بنا",
      philosophy: "نقوم بتصميم وبرمجة ونشر منتجات برمجية خفيفة الوزن وواجهات سحابية أنيقة للشركات الناشئة كافّة."
    },
    contact: {
      privacyText: "اتصال آمن ومشفر بشهادة SSL 256-بت نشط.",
      anotherCta: "إرسال رسالة أخرى"
    },
    aboutPage: {
      meta: "ملخص الشركة المؤسسي",
      title: "تيرالوماكس الخاصة المحدودة",
      subtitle: "تأسست في 22 نوفمبر 2022",
      cin: "رقم تعريف الشركة / CIN",
      cinValue: "U72900DL2022PTC407338",
      addressLabel: "العنوان المسجل رسميًا",
      addressValue: "القطاع 5، فايشالي، غازي آباد، أوتار براديش، الهند - 201010",
      statusLabel: "حالة التأسيس والنشاط",
      statusValue: "نشطة (شركة خاصة غير مدرجة محدودة بالأسهم)",
      domainLabel: "المجال الرقمي البرمجي",
      domainValue: "هندسة البرمجيات والأنظمة الرقمية الراقية",
      paragraph1: "شركة تيرالوماكس الخاصة المحدودة (Teralumax Private Limited) هي مؤسسة تكنولوجية متميزة تأسست في 22 نوفمبر 2022. ونحن نعمل في نقطة التقاطع بين هندسة خلفية الأنظمة الصارمة ودقة التصميم البصري الخلاب، لنبتكر برمجيات توفر مرونة حقيقية بعيدًا عن النماذج التقليدية.",
      paragraph2: "بدءًا من منصات إدارة المساحات والمنشآت الذكية (Roomy™) ومنصات تصميم الويب لقواعد البيانات (SiteForces) إلى ألعاب الألغاز الحائزة على براءة هندسة هندسية (Arrow Escape على متجر Google Play)، تجسد تيرالوماكس بيئة حقيقية للإنشاء والابتكار الخالي من العيوب.",
      statIncorporation: "سنة التأسيس",
      statClass: "فئة الشركة",
      statClassVal: "برمجية خاصة",
      statActive: "حالة السجل",
      statActiveVal: "نشط ومعتمد"
    },
    leadershipPage: {
      meta: "مجلس الإدارة والتحكم",
      title: "أعضاء مجلس الإدارة",
      subtitle: "المهندسون اللامعون الذين يقودون مسارات تيرالوماكس التكنولوجية.",
      aboutAbhishek: "أبهيشيك بالو فاداف",
      roleAbhishek: "المؤسس والمدير العام التنفيذي",
      bioAbhishek: "أبهيشيك بالو فاداف (Abhishek Balu Vadave) هو المؤسس الإستراتيجي والمدير الإبداعي خلف شركة تيرالوماكس الخاصة المحدودة. مستلهمًا من مبادئ المنطق الحاسوبي والجمال البصري، يصمم المفاهيم المحورية للمنتجات لضمان تجربة مستخدم رائدة، مع التركيز على نقاوة الأكواد وسلامة البرمجة لإحياء مفهوم البرمجة كحرفة فنية قيمة.",
      aboutBalu: "بالو لاكشمان فاداف",
      roleBalu: "المدير الشريك وعضو الإدارة",
      bioBalu: "بالو لاكشمان فاداف شريك إداري أول في مجلس إدارة تيرالوماكس، ويقود مجالات الإشراف المالي، الامتثال واللوائح التنظيمية وتخطيط العمليات، مما يتيح لفريق المطورين التركيز المطلق على تحقيق أعلى درجات التميز التقني.",
      missionTitle: "فلسفتنا البرمجية",
      missionText: "نؤمن بأن البرمجيات يجب أن تكون رفيقًا طبيعيًا وبسيطًا للإنتاجية البشرية. نحن نفرض هيكلة واضحة وخفة متناهية في نقل البيانات مع سرعة استجابة فائقة."
    }
  }
};
